import React, { useEffect, useState, useRef, lazy } from 'react';
import { motion } from 'framer-motion';
const logos = [{
  id: 1,
  alt: 'Orden del Carmen',
  src: 'https://cdn.magicpatterns.com/uploads/oCBimMavqv9Bt14DV3fXuk/1.png'
}, {
  id: 2,
  alt: 'Sonesta International Hotels',
  src: 'https://cdn.magicpatterns.com/uploads/7QVj3spNc5kJVhzcFeLUGW/2.png'
}, {
  id: 3,
  alt: 'Orden de Predicadores',
  src: 'https://cdn.magicpatterns.com/uploads/p3arpi1MK4mEbN14XDVYtu/3.png'
}, {
  id: 4,
  alt: 'Universidad Industrial de Santander',
  src: 'https://cdn.magicpatterns.com/uploads/vHgSKs1QyeLPixnVB46tSQ/4.png'
}, {
  id: 5,
  alt: 'AMB',
  src: 'https://cdn.magicpatterns.com/uploads/pac13r7JD6unr9oZAYEXRF/5.png'
}, {
  id: 6,
  alt: 'Universidad Santo Tomás',
  src: 'https://cdn.magicpatterns.com/uploads/pxCQkMYWnP2ye9rf9FosMT/6.png'
}, {
  id: 7,
  alt: 'Metrolínea',
  src: 'https://cdn.magicpatterns.com/uploads/9VghPuQo51pzLpCyo7P6v3/7.png'
}, {
  id: 8,
  alt: 'Jardines La Colina',
  src: 'https://cdn.magicpatterns.com/uploads/8aEUgFgrmDZoJ5azsgKnHW/8.png'
}, {
  id: 9,
  alt: 'Jimfer Security',
  src: 'https://cdn.magicpatterns.com/uploads/w9Pexr4rSWhKX193parR2N/9.png'
}, {
  id: 10,
  alt: 'SaludCoop EPS',
  src: 'https://cdn.magicpatterns.com/uploads/nZmfNkBiXcBFnDvc39YCtK/10.png'
}];
export function InstitutionalTrust() {
  const scrollRef = useRef<HTMLDivElement>(null);
  const [activeIndex, setActiveIndex] = useState(0);
  const totalDots = Math.ceil(logos.length / 3);
  useEffect(() => {
    const container = scrollRef.current;
    if (!container) return;
    const handleScroll = () => {
      const scrollLeft = container.scrollLeft;
      const itemWidth = 224 + 20; // w-56 + gap-5
      const index = Math.round(scrollLeft / (itemWidth * 3));
      setActiveIndex(Math.min(index, totalDots - 1));
    };
    container.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => container.removeEventListener('scroll', handleScroll);
  }, [totalDots]);
  return <section className="py-16 md:py-20 bg-white" data-id="element-106">
      <div className="container mx-auto max-w-6xl" data-id="element-107">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="md:text-4xl font-montserrat font-bold text-gray-900 text-center mb-10 px-4 text-[32px] pl-[0px] pr-[0px]" data-id="element-108">
          Conoce quiénes han{' '}
          <span className="text-gerfaj-orange" data-id="element-109">confiado</span> en nosotros
        </motion.h2>

        {/* Horizontal Scroll Gallery */}
        <div ref={scrollRef} className="flex gap-5 overflow-x-auto snap-x snap-mandatory px-6 pb-4 hide-scrollbar" style={{
        scrollbarWidth: 'none',
        msOverflowStyle: 'none'
      }} data-id="element-110">
          {logos.map(logo => <motion.div key={logo.id} initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: logo.id * 0.04
        }} className="snap-center flex-shrink-0 w-56 h-36 bg-gray-50 border border-gray-200 rounded-xl flex items-center justify-center p-5" data-id="element-111">
              <img src={logo.src} alt={logo.alt} className="max-w-full max-h-full object-contain" loading="lazy" decoding="async" data-id="element-112" />
            </motion.div>)}
          {/* Peek spacer */}
          <div className="flex-shrink-0 w-4" aria-hidden="true" data-id="element-113" />
        </div>

        {/* Pagination Dots */}
        <div className="flex justify-center gap-2 mt-5" data-id="element-114">
          {Array.from({
          length: totalDots
        }).map((_, i) => <div key={i} className={`w-2 h-2 rounded-full transition-all duration-300 ${i === activeIndex ? 'bg-gerfaj-orange w-4' : 'bg-gray-300'}`} data-id="element-115" />)}
        </div>
      </div>
    </section>;
}